import { ProfessionData } from '../types/professionTypes';
import { plombier } from './plombier';
import { electricien } from './electricien';
import { garagiste } from './garagiste';
import { restaurateur } from './restaurateur';
import { boulanger } from './boulanger';
import { carreleur } from './carreleur';
import { chauffagiste } from './chauffagiste';
import { menuisier } from './menuisier';
import { peintre } from './peintre';
import { aeronautique } from './aeronautique';
import { pharmaceutique } from './pharmaceutique';
import { agroalimentaire } from './agroalimentaire';
import { automobile } from './automobile';
import { construction } from './construction';

export const allProfessions: ProfessionData[] = [
  plombier,
  electricien,
  garagiste,
  restaurateur,
  boulanger,
  carreleur,
  chauffagiste,
  menuisier,
  peintre,
  aeronautique,
  pharmaceutique,
  agroalimentaire,
  automobile,
  construction
];

export function professionExists(slug: string): boolean {
  return allProfessions.some(profession => profession.slug === slug);
}

export function getProfessionData(slug: string): ProfessionData | undefined {
  return allProfessions.find(profession => profession.slug === slug);
}
